import { render, staticRenderFns } from "./LevelModal.vue?vue&type=template&id=ea89a83a&scoped=true&"
import script from "./LevelModal.vue?vue&type=script&lang=js&"
export * from "./LevelModal.vue?vue&type=script&lang=js&"
import style0 from "./LevelModal.vue?vue&type=style&index=0&id=ea89a83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea89a83a",
  null
  
)

export default component.exports